import React from 'react';
import { NavLink } from 'react-router-dom';
import { handleScrollReset } from '@/utils/navigationUtils';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Features', to: '/how-it-works' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
];

const HeaderNavigation: React.FC = () => {
  return (
    <nav className="hidden md:flex items-center gap-1">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          onClick={handleScrollReset}
          end={item.to === '/'}
          className={({ isActive }) =>
            `px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              isActive
                ? 'bg-white/15 text-white'
                : 'text-white/90 hover:bg-white/10 hover:text-white'
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default HeaderNavigation;
